import React from 'react';
import { Config } from '../features/common/Common.types';

interface ConfigurationProviderProps {
  children: JSX.Element;
  config: Config;
}

export const ConfigurationContext = React.createContext<Config | null>(null);
export default function ConfigurationProvider({
  children,
  config,
}: ConfigurationProviderProps) {
  return (
    <ConfigurationContext.Provider value={config}>
      {children}
    </ConfigurationContext.Provider>
  );
}
